import AuthForm from "./AuthForm";
import logoDarkTheme from "../../assets/images/logo_theme_dark.svg";
import logoLightTheme from "../../assets/images/logo_theme_light.svg";
import "./Auth.scss";
import LineIcon from "./Img/line.svg";

import { FC } from "react";
import Loader from "../../assets/components/Loader/Loader";
import { useAppSelector } from "../../assets/hooks/hooks";
import { Loading } from "../../redux/ui-slice";
import { Theme, useTheme } from "../../ThemeContext";
import { AuthMicrosoftButton } from "../../assets/components/AuthMicrosoftButton/AuthMicrosoftButton";

const Auth: FC = () => {
    const loading: Loading = useAppSelector((state) => state.auth.loading);
    const { theme } = useTheme();

    return (
        <div className="auth_page" type-theme={theme}>
            <Loader loading={loading} />
            <img
                className="auth_page__logo"
                src={theme === Theme.DARK ? logoDarkTheme : logoLightTheme}
                alt="Avanquest License Manager"
            />
            <AuthForm />

            <div className="auth_page__separator">
                <img
                    className="auth_page__separator_line"
                    src={LineIcon}
                    alt="line icon"
                />

                <div className="auth_page__separator_text">or Login with</div>
                <img
                    className="auth_page__separator_line"
                    src={LineIcon}
                    alt="line icon"
                />
            </div>

            <AuthMicrosoftButton />
        </div>
    );
};

export default Auth;
